import DataBreachScanner from "./DataBreachScanner";
import PasswordGenerate from "./PasswordGenerate";
import PasswordHealth from "./PasswordHealth";

const securityToolsComponents = {
  DataBreachScanner,
  PasswordGenerate,
  PasswordHealth
}

export default securityToolsComponents;